import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { LubavButton } from '@backrs_ui/grow-ui/src/components/Lubav/LubavButton';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.myColleges.compare.beforeYouBegin;

const SET_WEIGHTS_PROMPT_BUTTON_ID = 'compare_weights';

export const BeforeYouBegin = ({ onStart }: Readonly<{ onStart: () => void }>) => (
  <Box id="compare-before-you-begin" sx={bannerSx}>
    <Box sx={textRowSx}>
      <Box sx={dotRingSx}>
        <Box sx={dotCenterSx} />
      </Box>
      <Box>
        <Typography variant="text-xl-semibold" component="h2">
          {STRINGS.title}
        </Typography>
        <Typography variant="text-md-regular" sx={subtitleSx}>
          {STRINGS.subtitle}
        </Typography>
      </Box>
    </Box>
    <LubavButton
      id="compare-score-weights"
      label={STRINGS.button}
      promptButtonId={SET_WEIGHTS_PROMPT_BUTTON_ID}
      chatMessage={STRINGS.chatMessage}
      buttonSize="md"
      onClick={onStart}
    />
  </Box>
);

const bannerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-lg'],
  padding: backrs.spacing['spacing-2xl'],
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  backgroundColor: backrs.colors['Brand/50'],
});

const textRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-lg'],
  flex: '1 1 320px',
});

const dotRingSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '28px',
  height: '28px',
  marginTop: backrs.spacing['spacing-xxs'],
  borderRadius: backrs.radius['radius-full'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  backgroundColor: backrs.colors['Brand/100'],
  boxSizing: 'border-box',
});

const dotCenterSx: SxProps<Theme> = ({ backrs }) => ({
  width: '13px',
  height: '13px',
  borderRadius: backrs.radius['radius-full'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  backgroundColor: backrs.colors['Brand/500'],
  boxSizing: 'border-box',
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});
